import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';

interface PageBackgroundProps {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
}

const PageBackground: React.FC<PageBackgroundProps> = ({ children, sx }) => {
  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        height: 'auto',
        minHeight: 'calc(100vh - 100px)', // Account for header height
        overflow: 'auto',
        '&::before': {
          content: '""',
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          width: '100%',
          height: '100%',
          background: 'linear-gradient(135deg, #ffffff 0%, #f9f9f9 50%, #f5f5f5 100%)',
          backgroundImage: `
            radial-gradient(at 30% 20%, rgba(240, 240, 240, 0.8) 0px, transparent 50%),
            radial-gradient(at 80% 70%, rgba(245, 245, 245, 0.9) 0px, transparent 50%),
            linear-gradient(to bottom right, rgba(255, 255, 255, 0.8) 0%, rgba(240, 240, 240, 0.4) 100%)
          `,
          boxShadow: 'inset 0 0 100px rgba(0, 0, 0, 0.03)',
          zIndex: -1
        },
        ...(sx || {})
      }}
    >
      <Box sx={{ position: 'relative', zIndex: 2, p: { xs: 1.5, sm: 2 } }}>
        {children}
      </Box>
    </Box>
  );
};

export default PageBackground; 